export default __webpack_public_path__ + "static/media/ai_lidar.cd9d83bd.svg";